module.exports = __webpack_public_path__ + "img/curitibaebus3.9b67ecaf.png";